import { TVShortcutController } from '../../core/shortcut/tvshortcut';
import { KEYCODE_GENERICS_MAP } from '../../core/shortcut/types';

export const isValidateKeyboard = ({ keyCode }) => [13, 32].includes(keyCode);
export const isValidateTVKeyboard = (e) => {
  const mappedKeyCode = TVShortcutController.getMappedKeyCode(KEYCODE_GENERICS_MAP, e.keyCode);

  if (
    e.keyCode !== 32 /* space */
    && e.keyCode !== 13 /* enter */
    && mappedKeyCode !== 32 /* space equivalent on remote */
    && mappedKeyCode !== 13 /* enter equivalent on remote */
  ) {
    return false;
  }
  return true;
};
